import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { apiBaseURL } from '../system/Constants/API.js';

const initialState = {
  pdfData: {},
  branch: '',
};

const slice = createSlice({
  name: 'pdf',
  initialState,
  reducers: {
    setPDFData(state, action) {
      state.pdfData = action.payload;
    },
    setBranchName(state, action) {
      state.branch = action.payload;
    },
    }
});

export const reducer = slice.reducer;

export const setPDFData = (data) => async dispatch => {
  dispatch(slice.actions.setPDFData(data));
};

export const setBranchName = (data) => async dispatch => {
  dispatch(slice.actions.setBranchName(data));
};
